import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import langEn from "./lang.en.json";
import langKo from "./lang.ko.json";
import { LANGUAGE } from "../utils/Enum";

const resource = {
  [LANGUAGE.ENGLISH]: {
    translation: langEn,
  },
  [LANGUAGE.KOREAN]: {
    translation: langKo,
  },
};

i18n.use(initReactI18next).init({
  resources: resource,
  lng: LANGUAGE.KOREAN,
  fallbackLng: {
    [LANGUAGE.ENGLISH]: [LANGUAGE.ENGLISH],
    default: [LANGUAGE.KOREAN],
  },
  debug: true,
  defaultNS: "translation",
  ns: "translation",
  keySeparator: false,
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
});

export default i18n;
